<template>
  <div style="height: 100vh;background-color: #ffffff;">
    <div class="navbar w-100 nav-main" style="background-color:#23409A;color:white">
      <h3 class="w-100 text-center my-3">เช็คยอด</h3>
    </div>
    <div class="session-with-nav ">
      <CheckRegised :userData="userData" />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import CheckRegised from "@/components/checkbalance/checkRegised";
export default {
  components: { CheckRegised },
  data() {
    return {
      userData: null,
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
    profile() {
      return this.$store.state.profile;
    },
    userId() {
      return this.$store.state.profile.userId;
    },
    regised() {
      if (this.userId && this.userData && this.userData.cardnumber) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    userId: {
      immediate: true,
      handler(userId) {
        if (userId) {
          this.setup();
        }
      },
    },
  },
  mounted() {
    //   this.setup()
  },
  methods: {
    async setup() {
      await this.fetchUserData(this.userId);
    },
    close() {
      this.$liff.closeWindow();
    },
    async fetchUserData(userId) {
      if (userId) {
        let res = await api.getUser(userId);
        if (res.responsecode == 200 && res.data.id && res.data.cardnumber) {
          this.userData = res.data;
          this.loading = false;
        } else {
          this.$router.push("/checkbalancenoneregis");
          console.log("error fetch user data");
        }
      }
    },
  },
};
</script>

<style></style>
